export const CHANGE_PASSWORD_FORM = 'changePasswordForm'

export const OLD_PASSWORD_PROPERTY = 'oldPassword'
export const NEW_PASSWORD_PROPERTY = 'password'
export const NEW_PASSWORD_CONFIRMATION_PROPERTY = 'confirmPassword'
